import { Injectable } from '@angular/core';
import { map, of } from 'rxjs';

export interface ModuloBusca {
  value: number;
  label: string;
  rota: string;
}

// Mapeamento nome-da-rota ↔ ID do módulo
export const MODULO_ROTA_MAP: Record<string, number> = {
  'imobiliario':    234,
  'industrial':     5,
  'edificacoes':    6,
  'infraestrutura': 7,
};

export const MODULOS_IMOBILIARIO = [2, 3, 4];
export const MODULO_IMOBILIARIO_PARAM = '2,3,4';

export const MODULO_ID_ROTA_MAP: Record<number, string> = {
  2:   'imobiliario',
  3:   'imobiliario',
  4:   'imobiliario',
  234: 'imobiliario',
  5:   'industrial',
  6:   'edificacoes',
  7:   'infraestrutura',
};

export function montarParamsModulo(moduleId: number, moduleName: string) {
  if (MODULOS_IMOBILIARIO.includes(moduleId) || moduleId === 234) {
    return { moduleId: MODULO_IMOBILIARIO_PARAM, moduleName: 'Busca Imobiliária' };
  }

  return { moduleId: String(moduleId), moduleName };
}

export function getRotaPorModuleId(moduleId: number | string): string {
  const id = Number(moduleId);
  return MODULO_ID_ROTA_MAP[id] ?? 'imobiliario';
}

export function getModuloParamsPorRota(rota: string): { moduleId: string; moduleName: string } {
  const modulo = MODULO_ROTA_MAP[rota];

  if (rota === 'imobiliario') {
    return { moduleId: MODULO_IMOBILIARIO_PARAM, moduleName: 'Busca Imobiliária' };
  }

  const modulos = [
    { value: 5, label: 'Busca Industrial' },
    { value: 6, label: 'Busca Edificações' },
    { value: 7, label: 'Busca Infraestrutura' },
  ];

  const encontrado = modulos.find((m) => m.value === modulo);
  return {
    moduleId: String(modulo ?? ''),
    moduleName: encontrado?.label ?? '',
  };
}

@Injectable({ providedIn: 'root' })
export class ModulosBuscaService {

  private modulos: ModuloBusca[] = [
    { value: 234, label: 'Busca Imobiliária',   rota: '/buscas/imobiliario' },
    { value: 5,   label: 'Busca Industrial',     rota: '/buscas/industrial' },
    { value: 6,   label: 'Busca Edificações',    rota: '/buscas/edificacoes' },
    { value: 7,   label: 'Busca Infraestrutura', rota: '/buscas/infraestrutura' },
  ];

  // Existentes — mantidos sem alteração
  getModulos() {
    return of(this.modulos);
  }

  getModuloById(id: number) {
    return of(this.modulos.find((m) => m.value === id));
  }

  // Novos — conversão rota ↔ ID
  getIdByRota(rota: string): number | null {
    return MODULO_ROTA_MAP[rota] ?? null;
  }

  getRotaById(id: number): string | null {
    return MODULO_ID_ROTA_MAP[id] ?? null;
  }

  
}